import useRoutesStore from '~/stores/routes';
import { defineNuxtPlugin, useRouter } from '#app';

declare interface NavigationInformation {
  type: 'pop' | 'push';
  direction: 'back' | 'forward' | '';
  delta: number;
}

export default defineNuxtPlugin((nuxtApp) => {
  const isTransitioning = ref(false);
  nuxtApp.provide('isTransitioning', isTransitioning);

  const { getPathState } = useRoutesStore();
  const router = useRouter();

  let navigationInfo: NavigationInformation;

  router.options.history.listen((to, from, info) => {
    navigationInfo = info;
  });

  // REMOVED 'next' from the arguments
  router.beforeEach(async (to, from) => {
    const { current } = router.options.history.state;

    // Exception for scrolling logic
    if (to.meta.scrollToTop) {
      router.options.scrollBehavior = () => {
        return { top: 0, left: 0, behavior: 'smooth' };
      };
    }

    if (to.path !== from.path) {
      // 1. Handling hashes: Return 'false' instead of next(false)
      if (to.hash) {
        setTimeout(() => {
          const element = document.querySelector(to.hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
        return false;
      }

      isTransitioning.value = true;

      if (['back', 'forward'].includes(navigationInfo?.direction)) {
        if (
          (navigationInfo?.direction === 'forward' && current === to.path) ||
          (navigationInfo?.direction === 'back' && current === to.path)
        ) {
          const pathState = getPathState(to.path);
          if (pathState && pathState.loadMorePath) {
            const path = `${pathState.loadMorePath}`;
            const newTo = router.resolve(path);

            if (to.path !== newTo.path) {
              router.options.history.state.scroll = { top: 0, left: 0 };

              // 2. Redirect logic: Return the new location object instead of Object.assign
              return {
                path: newTo.path,
                query: newTo.query,
                params: newTo.params,
                hash: newTo.hash,
              };
            }
          }
        }
      }
    }

    // 3. To proceed normally, simply return or return true (or nothing)
    return;
  });

  router.afterEach(() => {
    setTimeout(() => {
      isTransitioning.value = false;
    }, 250);
  });
});
